/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MstTransportRelationUpdateBase } from './MstTransportRelationUpdateBase';
import {
    MstTransportRelationUpdateBaseFromJSON,
    MstTransportRelationUpdateBaseFromJSONTyped,
    MstTransportRelationUpdateBaseToJSON,
    MstTransportRelationUpdateBaseToJSONTyped,
} from './MstTransportRelationUpdateBase';

/**
 * 
 * @export
 * @interface MstTransportRelationUpdate
 */
export interface MstTransportRelationUpdate {
    /**
     * 
     * @type {Array<MstTransportRelationUpdateBase>}
     * @memberof MstTransportRelationUpdate
     */
    body: Array<MstTransportRelationUpdateBase>;
}

/**
 * Check if a given object implements the MstTransportRelationUpdate interface.
 */
export function instanceOfMstTransportRelationUpdate(value: object): value is MstTransportRelationUpdate {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function MstTransportRelationUpdateFromJSON(json: any): MstTransportRelationUpdate {
    return MstTransportRelationUpdateFromJSONTyped(json, false);
}

export function MstTransportRelationUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstTransportRelationUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': ((json['body'] as Array<any>).map(MstTransportRelationUpdateBaseFromJSON)),
    };
}

export function MstTransportRelationUpdateToJSON(json: any): MstTransportRelationUpdate {
    return MstTransportRelationUpdateToJSONTyped(json, false);
}

export function MstTransportRelationUpdateToJSONTyped(value?: MstTransportRelationUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': ((value['body'] as Array<any>).map(MstTransportRelationUpdateBaseToJSON)),
    };
}

